export const KEY_FALLBACK_UUID = "fallbackUUID";
